'use strict'

/**
 * External Dependencies
 */
import 'jquery'
import { getBrowser, isOldBrowser} from './utilities/browser-detection'
import 'gsap'
import 'slick-slider'
import 'howler'
import { gsap } from 'gsap'

let browser = getBrowser().browser
let browserVersion = getBrowser().version

gsap.config({
  force3D: true,
});

//console.log("You are using <b>" + browser + "</b> with version <b>" + browserVersion + "</b>");

if(isOldBrowser()) {
  $('body').addClass('ie-body')
}


require('./utilities/scene-setup');
require('./utilities/form-functions');
require('./home');

if($('.grid').length && !isOldBrowser()) {
  require('./hero-block')
}

if(!isOldBrowser()) {
  require('./elements/node-cursor')
}


require('./elements/cookies')
require('./elements/popup-animation')
require('./elements/zoom-popup')

require('./elements/video-popup')
require('./elements/timeline-popup')
require('./elements/search-popup')

require('./popup/your-story')
require('./popup/audio-timeline-popup')

let smoothScroll = $('.smooth-scroll')

if(smoothScroll.length && !isOldBrowser()) {
  if(smoothScroll.hasClass('audio-timeline')) {
    require('./audio-timeline')
  } else {
    require('./utilities/WidgetAPI');
    require('./timeline');
  }

} else {
  $('html').addClass('no-timeline')
}

if(browser === 'Firefox') {
  $('.js-timeline-popup .popup-content-c').css({'height':'100vh', 'overflow':'auto', 'scrollbar-width':'none'})
  $('.js-your-story-form-popup .popup-wrapper').css({'height':'100vh', 'overflow':'auto', 'scrollbar-width':'none'})
}


